import { render, staticRenderFns } from "./MobileDealForm.vue?vue&type=template&id=0bd5894a&"
import script from "./MobileDealForm.vue?vue&type=script&lang=js&"
export * from "./MobileDealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports